import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
   DictionaryEntry,
   DictionaryListDto,
   DictionaryListResponseDto
} from './types/dictionary-list.dto';
import { routes } from '../config/routes.config';
import { Observable } from 'rxjs';
import { DictionaryCreateDto, DictionaryUpdateDto } from './types/dictionary-create.dto';
import { DictionaryDeleteDto } from './types/dictionary-delete.dto';

@Injectable({
   providedIn: 'root'
})
export class DictionaryService {
   constructor(private httpClient: HttpClient) {}

   list(data: DictionaryListDto): Observable<DictionaryListResponseDto> {
      return this.httpClient.get<DictionaryListResponseDto>(routes.dictionary, {
         params: {
            ...data
         }
      });
   }

   create(data: DictionaryCreateDto): Observable<DictionaryEntry> {
      return this.httpClient.post<DictionaryEntry>(routes.dictionary, data);
   }

   update(data: DictionaryUpdateDto): Observable<DictionaryEntry> {
      return this.httpClient.patch<DictionaryEntry>(routes.dictionary, data);
   }

   delete(data: DictionaryDeleteDto): Observable<void> {
      return this.httpClient.delete<void>(routes.dictionary, { body: data });
   }
}
